import * as React from 'react'
import { View } from 'react-native'
import { Skeleton } from '@components/Skeleton'
import { Spacer } from '@components/Spacer'
import { cardStyles } from './shared'

export function LoadingNeedCardView() {
  return (
    <>
      {/* organization */}
      <View style={cardStyles.header}>
        <Skeleton size={24} isCircle />
        <Spacer width={8} />
        <Skeleton width={166} height={12} />
      </View>

      {/* {need} */}
      <View style={cardStyles.body}>
        <Skeleton width={244} height={24} />
        <Spacer height={8} />
        <Skeleton width="100%" height={16} />
        <Spacer height={4} noShrink />
        <Skeleton width="61.8%" height={16} />
      </View>

      <View style={cardStyles.footer}>
        <Skeleton width={59} height={16} />
        <Skeleton width={95} height={12} />
      </View>
    </>
  )
}
